import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryAppInfos(
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/app-infos`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryAppInfo(appInfoId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/app-infos/${appInfoId}`,
    method: 'get',
  });
}

export function _queryAppInfoByType() {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/app-infos/type`,
    method: 'get',
  });
}
/**
 * 新增
 * @param  title
 * @param  content
 * @param  code
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addAppInfo(
  {
    title,
    content,
    code,
    type,
    description,
    contentEn,
    descriptionEn,
    titleEn,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/app-infos`,
    method: 'post',
    data: {
      title,
      content,
      code,
      type,
      description,
      contentEn,
      descriptionEn,
      titleEn,
    },
  });
}

/**
 * 更新
 * @param appInfoId
 * @param  title
 * @param  content
 * @param  code
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateAppInfo(appInfoId, {
  title,
  content,
  code,
  type,
  description,
  contentEn,
  descriptionEn,
  titleEn,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/app-infos/${appInfoId}`,
    method: 'patch',
    data: {
      title,
      content,
      code,
      type,
      description,
      contentEn,
      descriptionEn,
      titleEn,
    },
  });
}

/**
 * 删除
 * @param appInfoId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteAppInfo(appInfoId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/app-infos/${appInfoId}`,
    method: 'delete',
  });
}

export default {};
